<template lang="pug">

.ov(ref="cbody")
	Loading(v-show="initialFail && !isOvReady")

	transition(name='fade')
		.ov-banner(v-show="isOvReady")
			Advertisement(
				path="/21839709139/JV_RESUMEN",
				:size="[[640, 100], [320, 100]]",
				:viewports="[[[640, 100], [640, 100]], [[0, 0], [320, 100]]]",
				id="jv_resumen"
			)
	transition(name='fade')
		.ov-high(v-show="isOvLocalReady && isOvVisitorReady")
			h3(v-if="isPlaying") {{ $t("Five playing") }}
			h3(v-if="isFinished") {{ $t("Starter players") }}
			Loading(v-if="!isOvLocalReady || !isOvVisitorReady")
			.ov-high-table-wrap(v-show="isOvLocalReady && isOvVisitorReady" :key="idMatch")
				.ov-high-table
					.ge-head_team.ge-head_team--center
						img.ge-head_team__img(:src="$store.state.match.localImage", :alt="$store.state.match.localShortName")
						span.ge-head_team__name {{ $store.state.match.localShortName }}
					.ta-wrap
						BoxScoreTable(team='local' class="ta--bo" :key="'local'")
				.ov-high-table
					.ge-head_team.ge-head_team--center
						img.ge-head_team__img(:src="$store.state.match.visitorImage", :alt="$store.state.match.visitorShortName")
						span.ge-head_team__name {{ $store.state.match.visitorShortName }}
					.ta-wrap
						BoxScoreTable(team='visiting' class="ta--bo" :key="'visiting'")
			router-link.ge-btn(
				role="button"
				@click="goTop"
				:to="{name: $store.state.general.lang+'.boxscore',	params: {id_match: $route.params.id_match}}"
			) {{ $t("See more") }}
	transition(name='fade')
		.ov-lead(v-show="isOvLocalReady && isOvVisitorReady && isLeadersReady" :key="idMatch")
			h3 {{ $t("Leaders") }}
			Loading(v-if="!isLeadersReady")
			.do-wrap.do-wrap--ov(v-show="isLeadersReady")
				LeadersStat(:stat="val" :key="val.name")
				LeadersStat(:stat="score" :key="score.name")
				LeadersStat(:stat="rb" :key="rb.name")
				LeadersStat(:stat="asis" :key="asis.name")
			router-link.ge-btn(
				role="button"
				:to="{name: $store.state.general.lang+'.leaders', params: {id_match: $route.params.id_match}}"
				@click="goTop"
			) {{ $t("See more") }}
	transition(name='fade')
		.ov-vers(v-show="isOvLocalReady && isOvVisitorReady && isLeadersReady && isVersusReady")
			h3 {{ $t("Head-to-Head") }}
			Versus(:key="idMatch")
			router-link.ge-btn(
				role="button"
				:to="{name: $store.state.general.lang+'.globals'}"
				@click="goTop"
			) {{ $t("See more") }}

</template>

<style lang="sass">

.ov
	display: grid
	max-width: 1000px
	margin: 0 auto
	grid-auto-flow: row
	justify-items: center
	padding: 2rem 1rem
		bottom: 16rem
	// grid-gap: 7rem
	overflow-x: none
	& > *
		display: grid
		grid-auto-flow: row
		justify-items: center
		grid-gap: 2rem
		+breakpoint(medium)
			grid-gap: 3rem


	&-high, &-lead, &-vers
		padding-bottom: 6rem
		+breakpoint(medium)
			padding-bottom: 8rem


	&-banner
		position: relative
		display: flex
		width: 100%
		z-index: 3
		justify-content: center
		bottom: 0
		left: 0
		margin: 0 -1rem
			bottom: 3rem
		+breakpoint(medium)
			z-index: 2

	&-high
		width: 100%

		&-table
			display: grid
			grid-auto-flow: row
			margin: 1rem 0
			grid-gap: 1rem
			+breakpoint(medium)
				margin: 0 1rem
			&-wrap
				display: flex
				width: 100%
				flex-wrap: wrap
				justify-content: space-around
			.ta-wrap
				padding: 0
	&-lead
	&-vers
		width: 100%
		.vs-gra-subwrap
			padding-bottom: 0
			+breakpoint(medium)
				padding-bottom: 1rem

</style>

<script>
import api from "@/api/index.js";

import Advertisement from "@/components/subcomponents/general/Advertisement.vue";
import Loading from "@/components/subcomponents/general/Loading.vue";
import NavQuarter from "@/components/subcomponents/nav/NavQuarter.vue";
import LeadersStat from "@/components/subcomponents/leaders/LeadersStat.vue";
import Versus from "@/components/subcomponents/versus/Versus.vue";
import BoxScoreTable from "@/components/subcomponents/BoxScoreTable.vue"


export default {
	name: "Overview",
	data() {
		return {
			val: {
				local_team: [{ val: 0 }],
				visiting_team: [{ val: 0 }]
			},
			score: {
				local_team: [{ val: 0 }],
				visiting_team: [{ val: 0 }]
			},
			rb: {
				local_team: [{ val: 0 }],
				visiting_team: [{ val: 0 }]
			},
			asis: {
				local_team: [{ val: 0 }],
				visiting_team: [{ val: 0 }]
			},
			initialFail: false,
			initialTimer: null
		};
	},
	computed: {
		isOvLocalReady() {
			return this.$store.state.general.isOvLocalReady;
		},
		isOvVisitorReady() {
			return this.$store.state.general.isOvVisitorReady;
		},
		isLeadersReady() {
			return this.$store.state.general.isLeadersReady;
		},
		isVersusReady() {
			return this.$store.state.general.isVersusReady;
		},
		idMatch() {
			return this.$route.params.id_match;
		},
		isPlaying() {
			return this.$store.state.match.status == "playing";
		},
		isFinished() {
			return this.$store.state.match.status == "finished";
		},
		actual() {
			return this.$store.state.general.actual;
		},
		isUpcoming() {
			return this.$store.state.match.status == 'upcoming'
		},
		refreshSignal() {
			return this.$store.state.general.refreshSignal;
		},
		isHeadReady() {
			return this.$store.state.general.isHeadReady
		},
		isOvReady() {
			return (
				this.isOvLocalReady &&
				this.isOvVisitorReady
			)
		}
	},

	methods: {
		updateLeaders() {
			api.match
				.getLeaders(
					this.$route.params.id_match
				)
				.then(data => {
					this.$data.val = data.val;
					this.$data.score = data.score;
					this.$data.rb = data.rb;
					this.$data.asis = data.asis;
				});
		},
		goTop() {
			this.$parent.goTop();
		},
		setInitialTimer() {
			this.initialTimer = setTimeout(
				() => {
					this.$data.initialFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearInitialTimer() {
			if (this.initialTimer) {
				this.$data.initialFail = false
				clearTimeout(this.initialTimer)
			}
		}
	},
	watch: {
		idMatch() {
			this.$store.commit("general/setOvLocalReady", false);
			this.$store.commit("general/setOvVisitorReady", false);
			this.$store.commit("general/setLeadersReady", false);
			this.updateLeaders();
		},
		refreshSignal(newValue) {
			if (newValue) {
				if (this.$store.state.match.status == "playing" || this.$store.state.general.refreshing)
					this.updateLeaders();
			}
		}
	},
	created() {
		this.setInitialTimer()
		if (this.actual.competition && this.actual.edition) this.updateLeaders();
		this.$store.commit("general/setOvLocalReady", false);
		this.$store.commit("general/setOvVisitorReady", false);
		this.$store.commit("general/setLeadersReady", false);
	},
	mounted() {
		this.$parent.triggerGlobalRefresh()
		this.$parent.goTop();
	},
	components: {
		Loading,
		NavQuarter,
		LeadersStat,
		Versus,
		BoxScoreTable,
		Advertisement,
	}
};
</script>
